import { gql } from "@outschool/ui-apollo";

export const UpdateFilestackMetadataMutation = gql`
  mutation updateFilestackMetadata($handle: String!, $osS3Path: String!) {
    updateFilestackMetadata(handle: $handle, osS3Path: $osS3Path)
  }
`;
